import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  menu: {
    minWidth: 280,
  },
  chatList: {
    width: '100%',
  },
  chatItem: {
    color: '#333',
    fontSize: 14,
    padding: '8px 16px',
    display: 'flex',
    opacity: 0.6,
    alignItems: 'center',

    '&.--not-read': {
      opacity: 1,
    },

    '&:hover': {
      background: '#f9f9f9',
    },
  },
  chatImage: {
    width: 42,
    height: 42,
    backgroundColor: '#eee',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderRadius: '100%',
    marginRight: 12,
    position: 'relative',
    border: '1px solid #ddd',

    '& span': {
      width: 12,
      height: 12,
      borderRadius: '100%',
      background: '#ccc',
      position: 'absolute',
      top: -2,
      left: 0,
      zIndex: 2,
    },

    '&.--not-read': {
      '& span': {
        backgroundColor: '#087922',
      },
    },
  },
  chatTitle: {
    fontWeight: 500,
    display: 'block',
    marginBottom: 4,
  },

  chatText: {
    color: '#999',
    marginBottom: 4,
    display: 'block',
  },

  chatDate: {
    fontSize: 12,
    color: '#999',
  },

  viewMore: {
    textAlign: 'center',
    color: '#333',
    display: 'block',
    width: '100%',
    padding: 8,
    fontSize: 13,
    fontWeight: 500,
  },

  loading: {
    minWidth: 280,
    textAlign: 'center',
    padding: '12px 0',
  },

  badgeAvatar: {
    width: 20,
    height: 20,
    borderRadius: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'absolute',
    bottom: -4,
    right: -4,
    zIndex: 2,

    '&.--hasBadge': {
      backgroundColor: 'white',
    },
  },
  emptyMessage: {
    padding: theme.spacing(1),
  },
}));
